import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons';
import { Auth } from '../../../../core/auth/auth';
import { PopupInfoService } from '../../../../shared/services/popup-info.service';

@Component({
  selector: 'app-on-boarding-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, FontAwesomeModule],
  templateUrl: './on-boarding-page.html',
  styleUrl: './on-boarding-page.scss',
})
export class OnBoardingPage implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly auth = inject(Auth);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly popupInfoService = inject(PopupInfoService);

  faLock = faLock;

  token = '';
  email = '';
  isLoading = false;
  errorMessage = '';

  form = this.fb.nonNullable.group({
    password: ['', [Validators.required, Validators.minLength(8)]],
    password_confirmation: ['', [Validators.required]],
  });

  ngOnInit(): void {
    // Obtener token y email de los query params
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'] || '';
      this.email = params['email'] || '';

      if (!this.token || !this.email) {
        this.popupInfoService.showError(
          'Enlace de recuperación inválido. Por favor, solicita uno nuevo.'
        );
        void this.router.navigateByUrl('/login');
      }
    });
  }

  submit(): void {
    this.errorMessage = '';

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { password, password_confirmation } = this.form.getRawValue();

    if (password !== password_confirmation) {
      this.errorMessage = 'Las contraseñas no coinciden.';
      return;
    }

    this.isLoading = true;
    this.auth.resetPassword(this.token, this.email, password, password_confirmation).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.popupInfoService.showSuccess(
          response.message || 'Contraseña restablecida correctamente.'
        );
        setTimeout(() => {
          void this.router.navigateByUrl('/login');
        }, 1500);
      },
      error: () => {
        this.isLoading = false;
        const errorMessage =
          'Error al restablecer la contraseña, por favor inténtalo de nuevo más tarde.';
        this.popupInfoService.showError(errorMessage);
      },
    });
  }
}
